export function SuccessNewsletterSubscription() {
    return (
        <div style={{ height: "60vh" }}>
            <div style={{ height: "100%", position: "relative", display: "flex", flexDirection: "column", alignItems: "center", marginTop: "15vh", gap: "3vh" }}>
                <h1 style={{ textAlign: "center" }}>Merci pour votre inscription!</h1>
                <div style={{ width: "80%", textAlign: "center" }}>La newsletter arrive vite, si vous avez des questions, n'hésitez pas à nous contacter.</div>
            </div>
        </div>
    )
}